module.exports = __webpack_public_path__ + "static/img/brush-twice-a-day.5921bb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brush-twice-a-day.svg
// module id = kXXK
// module chunks = 0